import Provider from "./Provider-Api";
import CheckApi from "./check-api";

// Queue MANAGEMENT

export const queueGetQueueByDate = async (data, token) => {
    CheckApi('getQueueByDate', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/queue/getQueueByDate",
        data,
        token
    });
    CheckApi('dataRes-getQueueByDate', dataRes)
    return dataRes;
};

export const queueGetQueue = async (data, token) => {
    CheckApi('getQueue', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/queue/getQueue",
        data,
        token
    });
    CheckApi('dataRes-getQueue', dataRes)
    return dataRes;
};

export const queueAddQueue = async (data, token) => {
    CheckApi('addQueue', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/queue/addQueue",
        data,
        token
    });
    CheckApi('dataRes-addQueue', dataRes)
    return dataRes;
};

export const queueDeleteQueue = async (item, token) => {
    CheckApi('deleteQueue', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/queue/deleteQueue",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteQueue', dataRes)
    return dataRes;
};

export const queueUpdateQueue = async (data, token) => {
    CheckApi('updateQueue', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/queue/updateQueue",
        data,
        token
    });
    CheckApi('dataRes-updateQueue', dataRes)
    return dataRes;
};

// END Queue MANAGEMENT